import * as React from 'react'

import { Field } from 'embed/constants'

import PlaidStatusIndicator from 'embed/components/ConnectPlaid/StatusIndicator'
import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  handleChangeAndContinue: (field: Field, value: string) => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

export const StepbystepApplicationStepPlaidSummary: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <div>
      <PlaidStatusIndicator showSummaryCard={true} />
    </div>
  </Wrapper>
)
